'use strict';

/**
 * Controller for budget management
 * @description
 * Contains functions for handling tabs and table columns logic
 *
 * @param $scope
 * @param $state
 *
 * @watch $stateChangeStart
 * Watches on the start of state change, set status and params
 *
 * @author H.W. Liew <liewhanwahwork@gmail.com>
 * @author Justin Cheong <justin.cty90@gmail.com>
 * @author Khor Jin Ee <jinee585@gmail.com>
 * @copyright 2017 Metacloud Sdn. Bhd.
 */
function budgetManagementCtrl($scope, $state, globalFunc) {
  $scope.$emit('pageTitleChanged', 'Budgets List');
  $scope.tabData = [
    {
      heading: 'Draft',
      route: 'main.user.budget.manage',
      key: 'draft',
      id: 'draftBudgetsTab',
      params: {
        status: 'draft',
        cursor: null,
        order_by: 'descr',
        order: 1,
        filter: null,
        query: null,
        type: null
      }
    },
    {
      heading: 'Pending',
      route: 'main.user.budget.manage',
      key: 'pending',
      id: 'pendingBudgetsTab',
      params: {
        status: 'pending',
        cursor: null,
        order_by: 'descr',
        order: 1,
        filter: null,
        query: null,
        type: null
      }
    },
    {
      heading: 'Approved',
      route: 'main.user.budget.manage',
      key: 'approved',
      id: 'approvedBudgetsTab',
      params: {
        status: 'approved',
        cursor: null,
        order_by: 'descr',
        order: 1,
        filter: null,
        query: null,
        type: null
      }
    }
  ];

  $scope.tabData.more = [
    {
      heading: 'Expired',
      route: 'main.user.budget.manage',
      key: 'expired',
      id: 'expiredBudgetsTab',
      type: 'more',
      params: {
        status: 'expired',
        cursor: null,
        order_by: 'descr',
        order: 1,
        filter: null,
        query: null
      }
    },
    {
      heading: 'Withdrawn',
      route: 'main.user.budget.manage',
      key: 'withdraw',
      id: 'withdrawnBudgetsTab',
      type: 'more',
      params: {
        status: 'withdraw',
        cursor: null,
        order_by: 'descr',
        order: 1,
        filter: null,
        query: null
      }
    },
    {
      heading: 'Rejected',
      route: 'main.user.budget.manage',
      key: 'rejected',
      id: 'rejectedBudgetsTab',
      type: 'more',
      params: {
        status: 'rejected',
        cursor: null,
        order_by: 'descr',
        order: 1,
        filter: null,
        query: null
      }
    },
    {
      heading: 'Inactive',
      route: 'main.user.budget.manage',
      key: 'inactive',
      id: 'inactiveBudgetsTab',
      type: 'more',
      params: {
        status: 'inactive',
        cursor: null,
        order_by: 'descr',
        order: 1,
        filter: null,
        query: null
      }
    },
    {
      heading: 'On Hold',
      route: 'main.user.budget.manage',
      key: 'on hold',
      id: 'onHoldBudgetsTab',
      type: 'more',
      params: {
        status: 'on hold',
        cursor: null,
        order_by: 'descr',
        order: 1,
        filter: null,
        query: null
      }
    },
    {
      heading: 'Deleted',
      route: 'main.user.budget.manage',
      key: 'deleted',
      id: 'deletedBudgetsTab',
      type: 'more',
      params: {
        status: 'deleted',
        cursor: null,
        order_by: 'descr',
        order: 1,
        filter: null,
        query: null
      }
    }
  ];

  function initialize() {

    if (!!$state.params && !!$state.params.query) {
      $scope.searchText = $state.params.query;
    }
    else {
      $scope.searchText = '';
    }
    if (!!$state.params && !!$state.params.filter) {
      $scope.searchFilter = $state.params.filter;
    }

    if (!!$state.params && !!$state.params.status) {
      $scope.status = $state.params.status;
      //set the default tab on refreshing
      var tempIndex = _.findIndex($scope.tabData, function(tab){
        return tab.params.status === $state.params.status.toLowerCase();
      });

      if(tempIndex < 0) {
        var tempIndex2 = _.findIndex($scope.tabData.more, function (tab) {
          return tab.params.status === $state.params.status
        });
          if(tempIndex2 >= 0) {
          $scope.activatedTab = $scope.tabData.more[tempIndex2];
        }
      }
      else
        $scope.activatedTab = $scope.tabData[tempIndex];
    }

    $scope.searchPlaceholder = 'Search Budgets';
    $scope.searchState = 'main.user.budget.manage';
    $scope.parentState = 'main.user.budget.manage';
    $scope.parentStateParams = $state.params;
  }

  $scope.columns = [
    {
      id: 'check box',
      title: ' ',
      unsortable: true,
      unsearchable: true,
      conditional: true,
      condition: ['pending'],
      unSelectable: true
    },
    {id: 'code', label: 'Budget Code'},
    {id: 'descr', label: 'Title'},
    {id: 'company|descr', label: 'Company'},
    {id: 'cost_center|descr', label: 'Cost Center(s)', unsortable: true},
    {id: 'status', label: 'Status', unsearchable: true},
    {id: 'progress', label: 'Progress',
      condition: 'pending', conditional: true},
    {id: 'start_date', label: 'Start Date', type: 'date', unsearchable: true},
    {id: 'end_date', label: 'End Date', type: 'date', unsearchable: true},
    {id: 'amount', label: 'Amount', type: 'double', unsearchable: true},
    {id: 'used_amount', label: 'Used Amount',type: 'double', unsearchable: true,
      condition: 'approved', conditional: true},
    {id: 'committed_amount', label: 'Committed Amount',type: 'double', unsearchable: true,
      condition: 'approved', conditional: true},
    {id: 'block_amount', label: 'Block Amount',type: 'double', unsearchable: true,
      condition: 'approved', conditional: true},
    {id: 'available_balance', label: 'Available Balance',type: 'double', unsearchable: true,
      condition: 'approved', conditional: true},
    {id: 'created_at', label: 'Created At', type: 'date', unsearchable: true},
    {id: 'creator.display_name', label: 'Created By'},
    {id: 'updated_at', label: 'Updated At', type: 'date', unsearchable: true},
    {id: 'updater.display_name', label: 'Updated By'},
    {
      id: 'delete_button',
      label: '',
      unsortable: true,
      unsearchable: true,
      unSelectable: true
    }
  ];

  $scope.$on('$stateChangeStart', function( event, toState, toParams ) {
    if(!!toParams.status){
      $scope.status = toParams.status;
      $scope.parentStateParams = toParams;
    }
  });

  initialize();
}
budgetManagementCtrl.$inject = ['$scope', '$state', 'globalFunc'];

angular.module('metabuyer')
  .controller('budgetManagementCtrl', budgetManagementCtrl);
